import script from "./question-detail-17.vue?vue&type=script&lang=tsx&setup=true"
export * from "./question-detail-17.vue?vue&type=script&lang=tsx&setup=true"

import "./question-detail-17.vue?vue&type=style&index=0&id=b21250fe&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/.store/vue-loader@17.4.2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b21250fe"]])

export default __exports__